{
  "nl": {
    "ai": {
      "assistant": {
        "all_projects": "Alle projecten",
        "cap": {
          "action": "Start een nieuw gesprek",
          "message": "U heeft de gespreksbeperking bereikt."
        },
        "empty_state": {
          "subtitle": "Stel me alles over uw klanten",
          "title": "Hoe kan ik u helpen?"
        },
        "errors": {
          "budget_reached": "Het maandelijkse AI-budget voor deze werkomgeving is bereikt. Neem contact op met een beheerder om de limiet te verhogen.",
          "generic": "Er is iets misgegaan. Probeer het opnieuw."
        },
        "history": {
          "empty": "Nog geen vorige gesprekken",
          "title": "Vorige gesprekken"
        },
        "input": {
          "disclaimer": "Resultaten kunnen onnauwkeurig zijn. Controleer belangrijke informatie altijd.",
          "hint": "Enter om te verzenden · Shift+Enter voor nieuwe regel",
          "placeholder": "Vraag over uw klanten..."
        },
        "name": "Ziggy",
        "suggestions": {
          "help_notifications": "Hoe stel ik notificaties in?",
          "help_project_settings": "Waar vind ik project-instellingen?",
          "open_decisions": "Welke beslissingen staan nog open?",
          "unassigned_units": "Welke units hebben nog geen klant?"
        },
        "support_cta": {
          "action": "Neem contact op met support",
          "prompt": "Antwoord niet wat u zocht?"
        }
      },
      "settings": {
        "budget": {
          "budget_label": "Budget",
          "description": "Maximale kost per maand voor AI-gebruik (test-fase). Wordt herberekend op basis van token-verbruik van alle gesprekken deze maand.",
          "save": "Opslaan",
          "title": "Maandelijks budget",
          "usage_label": "Verbruikt deze maand"
        },
        "description": "Configuratie voor AI-functies binnen jullie werkomgeving.",
        "title": "AI-instellingen"
      }
    }
  }
}
